export default "__VITE_ASSET__LWDit6L9__"